import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsContactBannerBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsContactBannerBlockEntity
